export const ToolTrackerConstants = {
  _PART: 'Part',
  _EQUIPMENT: 'Equipment',
  _JOBSITE: 'JobSite',
  _TRAILER: 'Trailer',
  _TOOLBOX: 'Toolbox',
  _PERSON: 'Person',
  _WAREHOUSE: 'Warehouse',
  _KIT: 'Kit',
};
